module.exports = __webpack_public_path__ + "img/IFrame.d9106127.png";